import { StorefrontSliderServiceModule } from './storefrontSlider.service';
import { StorefrontSliderDirectiveModule } from './storefrontSlider.directive';
import { OpenStorefrontSliderModule } from './openStorefrontSlider.directive';

export const StorefrontSliderModule = angular
    .module('vln.storefrontSlider', [
        StorefrontSliderServiceModule,
        StorefrontSliderDirectiveModule,
        OpenStorefrontSliderModule
    ]).name;


// WEBPACK FOOTER //
// ./src/app/components/storefrontSlider/storefrontSlider.module.js